import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import DividerAtm from "@onestore/hel/dist/components/atoms/DividerAtm"
import PlainLinkAtm from "@onestore/hel/dist/components/atoms/PlainLinkAtm"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { SitemapSectionFlataData } from "@gatsby-plugin-generic-page/fragments/sitemapSection"
import useMarketplaceSitemapQuery from "@gatsby-plugin-generic-page/hooks/useMarketplaceSitemapQuery"
import GenericPageSitemap from "@gatsby-plugin-generic-page/sections/SitemapSection/components/GenericPageSitemap"
import MarketplaceSitemap from "@gatsby-plugin-generic-page/sections/SitemapSection/components/MarketplaceSitemap"
import isEmpty from "~/lib/isEmpty"

const SitemapSection = ({
  header,
  sectionSettings,
}: SitemapSectionFlataData): ReactElement<SitemapSectionFlataData> => {
  const marketplacePages = useMarketplaceSitemapQuery()

  return (
    <BaseSection {...sectionSettings}>
      <BaseContainer {...sectionSettings?.containerSettings}>
        {header ? (
          <PushOrg bottomSpace={4}>
            <Header {...header} />
          </PushOrg>
        ) : null}

        <SurfaceOrg
          color="backgroundLight"
          spacingSpace={5}
          borderRadiusSize="xlarge"
        >
          <PushOrg bottomSpace={4}>
            <PlainLinkAtm
              title={_t("mainPage")}
              typography="large3"
              type="underline"
              to="/"
            >
              {_t("mainPage")}
            </PlainLinkAtm>
          </PushOrg>

          <GenericPageSitemap />

          {!isEmpty(marketplacePages) ? (
            <>
              <DividerAtm emphasis="extraLow" type="solid" marginSpace={4} />

              <PushOrg bottomSpace={4}>
                <PlainLinkAtm
                  title={_t("marketplace.name")}
                  typography="large3"
                  type="underline"
                  to="/marketplace"
                >
                  {_t("marketplace.name")}
                </PlainLinkAtm>
              </PushOrg>

              <MarketplaceSitemap marketplacePages={marketplacePages} />
            </>
          ) : null}
        </SurfaceOrg>
      </BaseContainer>
    </BaseSection>
  )
}

export default SitemapSection
